import type { ObservationEntity } from "@/entities/observation";
import type { AncestorsBreadcrumbItem } from "@/modules/ancestors/ancestors-breadcrumb";

export const getObservationBreadcrumbItems = (
  observation?: ObservationEntity
) => {
  if (!observation?.ancestors?.length) return [];

  return observation.ancestors.map((ancestor): AncestorsBreadcrumbItem =>
    ancestor.type === "intervention"
      ? { ...ancestor, showState: true }
      : ancestor
  );
};
